var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXamarin48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#039be5",
    d: "M32.876,5H15.124c-1.136,0-2.253,0.651-2.816,1.65L3.422,22.34c-0.563,1.01-0.563,2.31,0,3.32l8.886,15.69c0.563,1,1.68,1.65,2.816,1.65h17.752c1.136,0,2.253-0.651,2.816-1.65l8.886-15.69c0.563-1.01,0.563-2.31,0-3.32L35.692,6.65C35.129,5.651,34.012,5,32.876,5L32.876,5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.612,34h-3.051c-0.143,0-0.285-0.089-0.352-0.217l-5.161-9.585c-0.029-0.05-0.038-0.109-0.048-0.158c-0.01,0.049-0.019,0.109-0.048,0.158l-5.18,9.585c-0.057,0.128-0.19,0.207-0.333,0.217h-3.051c-0.276,0-0.485-0.366-0.342-0.623L20.093,24l-5.047-9.397c-0.124-0.227,0.028-0.553,0.266-0.603h3.127c0.133,0,0.266,0.089,0.333,0.208l5.18,9.585c0.028,0.049,0.038,0.099,0.048,0.158c0.01-0.059,0.019-0.109,0.048-0.158l5.161-9.585C29.285,14.079,29.418,14,29.561,14h3.051c0.266,0,0.466,0.356,0.342,0.603L27.907,24l5.047,9.377C33.097,33.634,32.887,34,32.612,34z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXamarin48);
export default __webpack_public_path__ + "static/media/xamarin-48.07df356c2b097b648209c56333eed9e5.svg";
export { ForwardRef as ReactComponent };